<template>
	<div class="brick">
		<div class="list_top_box">
			<span class="int_type_no_border mgr_15">
				<em class="lt_text">Customer Code</em>
				<span class="int_type sm_int mgr_5">
					<input type="text" v-model.trim="bill_to_code" placeholder="(optional)" autocomplete="off" @keyup.enter="search" />
				</span>
			</span>

			<span class="int_type_no_border mgr_15">
				<em class="lt_text">Sales Rep</em>
				<span class="int_type sm_int mgr_5">
					<input type="text" v-model.trim="sales_group_code" placeholder="(optional)" autocomplete="off" @keyup.enter="search" />
				</span>
			</span>

			<a href="javascript: void(0);" class="search_bt" @click="search">Search</a>
			<a href="javascript: void(0);" class="gray_bt mgr_15" @click="reset">Reset</a>

			<span class="int_type_no_border">
				<a href="javascript: void(0);" class="gray_bt" @click="print">Print</a>
				<a href="javascript: void(0);" class="gray_bt" @click="excelExport">Excel</a>
			</span>

			<span class="fl_r">
				<em class="lt_text"><b class="mgr_15">Open (un-invoiced) Sales Orders</b></em>
			</span>
		</div>

		<table class="list_tbl" id="soOnOrderDetail">
			<thead>
				<tr>
					<th>Customer #</th>
					<th>Customer Name</th>
					<th>Trans #</th>
					<th>Date</th>
					<th>Order Status</th>
					<th>Sales Rep</th>
					<th>Item #</th>
					<th>Description</th>
					<th>Ord Qty</th>
					<th>Open Qty</th>
					<th>U/M</th>
					<th>Unit</th>
					<th>Open Total</th>
					<th>Tel</th>
					<th>Contact 1</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row, index) in list" :key="index">
					<td class="al_left">{{ row.customer_code }}</td>
					<td class="al_left truncate">{{ row.customer_name }}</td>
					<td class="al_left">{{ row.so_dn }}</td>
					<td class="al_left">{{ row.so_date }}</td>
					<td class="al_left">{{ row.order_status }}</td>
					<td class="al_left">{{ row.sales_rep }}</td>
					<td class="al_left">{{ row.item_code }}</td>
					<td class="al_left truncate">{{ row.item_name }}</td>
					<td class="al_right">{{ row.ord_qty | commaSeparated }}</td>
					<td class="al_right">{{ row.open_qty | commaSeparated }}</td>
					<td class="al_left">{{ row.uom }}</td>
					<td class="al_right">{{ row.unit_price | toCurrency }}</td>
					<td class="al_right">{{ row.open_total | toCurrency }}</td>
					<td class="al_left">{{ row.telephone }}</td>
					<td class="al_left truncate">{{ row.contact1 }}</td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;padding-top:5px;">Total Count : {{ list.length | commaSeparated }}</div>
	</div>
</template>

<script>
import { apiSoOnOrderByCustomer } from '@/api/report/report';
import { apiGetReportTemplate, companyMrtUrl, Report, PrintType, exportExcel } from '@/api/util';
export default {
	data: () => ({
		bill_to_code: null,
		sales_group_code: null,
		list: [],
		total: {},
	}),
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
	},
	methods: {
		async search() {
			const { data } = await apiSoOnOrderByCustomer(this.bill_to_code, this.sales_group_code);
			this.list = data && Array.isArray(data.list) ? data.list : [];
			this.total = (data && data.total) || {};
		},
		async print() {
			if (this.list.length < 1) return this.$toast.error('No Data to Print.');
			const reportTemplate = await apiGetReportTemplate('SoOnOrderDetail', companyMrtUrl('SoOnOrderDetail'));
			const total = { ...this.total, print_dt: this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'), title: 'Open Order Detail by Customer' };
			const reportData = { list: this.list, total };
			const report = new Report(reportTemplate, reportData, 'SoOnOrderDetail', PrintType.Normal, false, false, null, 0);
			this.$store.commit('setReport', report);
		},
		excelExport() {
			if (this.list.length < 1) return this.$toast.error('No Data to Export.');
			exportExcel('soOnOrderDetail', 'SoOnOrderDetail');
		},
		reset() {
			this.bill_to_code = null;
			this.sales_group_code = null;
			this.list = [];
			this.total = {};
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_soOnOrderDetail');
		this.$store.commit('setSubTitle', 'Report -> Sales On Order Detail');
	},
};
</script>

<style></style>
